import { FC, RefObject } from 'react';
import { Box, Stack } from '@mui/material';
import { createUseStyles } from 'react-jss';
import FlatButton from '@/components/flat-button';
import MessageTray from './message-tray';
import Loader from '@/components/loader';
import useThread from '@/hooks/use-thread.hook';
import useMessageTray from '@/hooks/use-message-tray.hook';
import useUserSettings from '@/hooks/use-user-settings.hook';
import { addAction } from '@/lib/datadog';
import PublicInternetSearchButton from './public-internet-search-button';
import { getBreakpoint } from '@/theme';

interface Props {
  containerRef: RefObject<HTMLDivElement>;
}

const useStyles = createUseStyles({
  content: {
    margin: '0px 30px',
    width: 'calc(100% - 60px)',
    height: '100%',
  },
  [getBreakpoint('md')]: {
    content: {
      margin: '0px 10px',
      width: 'calc(100% - 20px)',
    },
  },
});

interface Props {
  containerRef: RefObject<HTMLDivElement>;
  disabled?: boolean;
}

const ThreadToolsTray: FC<Props> = ({ containerRef, disabled = false }) => {
  const styles = useStyles();

  const { thread } = useThread();

  const { isOpen, closeAll, toggle } = useMessageTray();
  const open = isOpen('tools');

  const { isLoading } = useUserSettings();

  const handleWaitClose = () => {
    setTimeout(() => {
      closeAll();
    }, 600);
  };

  const handleCloseTray = () => {
    closeAll();
  };

  const handleToggleTray = () => {
    if (!open) {
      addAction('thread_tools_open', { threadId: thread.id });
    }
    toggle('tools');
  };

  return (
    <Box>
      <MessageTray containerRef={containerRef} height={50} trayId="tools">
        {isLoading && (
          <Box width="100%">
            <Loader />
          </Box>
        )}
        {!isLoading && (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            className={styles.content}
          >
            <Stack direction="row" alignItems="center" justifyContent="flex-start">
              <PublicInternetSearchButton onChange={handleWaitClose} />
            </Stack>
            <Stack flexGrow={1} direction="row" alignItems="center" justifyContent="flex-end">
              <FlatButton icon="close" label="Close" size="small" onClick={handleCloseTray} />
            </Stack>
          </Stack>
        )}
      </MessageTray>

      <Stack direction="row" alignItems="center" justifyContent="flex-start">
        <FlatButton
          icon="tools"
          label="Tools"
          onClick={handleToggleTray}
          size="small"
          disabled={disabled}
        />
      </Stack>
    </Box>
  );
};

export default ThreadToolsTray;
